import { listMethod } from "./resource";
var resource = "addresses";
export var list = function list(client, request) {
  return listMethod({
    resource: resource,
    client: client
  })(request);
};